import React, { useContext } from "react";
import { CSVLink } from "react-csv";
import { FaFileCsv } from "react-icons/fa6";
import { Button, Typography, Stack } from "@mui/material";
import moment from "moment";
import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

export default function ExportStudentAttendanceCSV({ tableData }) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  // console.log("tableDataAttCVS", tableData);
  const createCsvFileName = () => `student_attendance_data.csv`;

  const headers = [
    { label: "ID", key: "stuId" },
    { label: "KhmerName", key: "kh_name" },
    { label: "LatinName", key: "latin_name" },
    { label: "Gender", key: "gender" },
    { label: "Date", key: "date" },
    { label: "Attendance", key: "attendance" },
    { label: "Reason", key: "reason" },
  ];
  let data = [];
  tableData?.forEach((element) => {
    data.push({
      stuId: element?.student_id?.student_id,
      kh_name: element?.student_id?.full_name_kh,
      latin_name: element?.student_id?.full_name_latin,
      gender: element?.student_id?.gender,
      date: moment(element?.attendance_date)?.format("DD-MM-YYYY"),
      attendance: element?.attendance_status,
      reason: element?.reason,
    });
  });
  return (
    <CSVLink
      data={data}
      headers={headers}
      filename={createCsvFileName()}
      target="_blank"
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="center"
      >
        <FaFileCsv className="icon-csv" />
        <Typography
          className={language === "en" ? "action-txt" : "action-txt-kh"}
        >
          {t("export")}
        </Typography>
      </Stack>
    </CSVLink>
    // <CSVLink
    //   data={data}
    //   headers={headers}
    //   filename={createCsvFileName()}
    //   target="_blank"
    // >
    //   <Button
    //     className="btn-create-style"
    //     // sx={{ marginTop: "30px !important" }}
    //     startIcon={<FaFileCsv className="icon-add" />}
    //   >
    //     <Typography className={language === "kh" ? "btn-txt-kh" : "btn-txt"}>
    //       {t("export")}
    //     </Typography>
    //   </Button>
    // </CSVLink>
  );
}
